/* ReviewsHeader.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _9 = "@media not all and (min-width:48rem){._sugaglyw{display:none}}";
const _8 = "._18s81h4g{margin:var(--ds-space-075,6px) 0}";
const _7 = "._19itzgxb{border:1px solid var(--ds-border,#091e4224)}";
const _6 = "@media not all and (min-width:48rem){._8164pxbi{gap:var(--ds-space-200,1pc)}._1gde1bp4{flex-direction:column}._ag851y6m{align-items:flex-start}}";
const _5 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _4 = "._1bah1yb4{justify-content:space-between}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { H6, SortDropdown } from '@atlassian/mpac-primitives';
import React from 'react';
import { ANALYTICS_REVIEW_SORT_BUTTON } from '../../../../../../analytics/Events';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyrxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const Content = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1h6o _1bah1yb4 _otyru2gc _8164pxbi _1gde1bp4 _ag851y6m", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Content.displayName = 'Content';
}
const Divider = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19itzgxb _18s81h4g _sugaglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Divider.displayName = 'Divider';
}
const sortOptions = [{
  value: 'recent',
  label: 'Newest'
}, {
  value: 'helpful',
  label: 'Most Helpful'
}];
export const ReviewsHeader = _ref4 => {
  let {
    ownReviewPresent = false,
    totalReviews,
    currentSortOption,
    sortReviewsBy
  } = _ref4;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const handleOnSortOptionSelect = sortOption => {
    sortReviewsBy(sortOption.value);
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_REVIEW_SORT_BUTTON,
      attributes: {
        label: 'Sort Review',
        value: sortOption.value
      }
    });
  };
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Content, {
      children: [ownReviewPresent ? /*#__PURE__*/_jsx(H6, {
        as: "h3",
        children: "Other reviews"
      }) : /*#__PURE__*/_jsxs(H6, {
        as: "h3",
        children: ["Showing ", totalReviews, " reviews"]
      }), /*#__PURE__*/_jsx(SortDropdown, {
        selectedSortKey: currentSortOption,
        onSortOptionSelect: handleOnSortOptionSelect,
        sortOptions: sortOptions
      })]
    }), /*#__PURE__*/_jsx(Divider, {})]
  });
};